
let defaultState = {

    state: "SEARCH_DONE", //  SEARCH_FETCHING, SEARCH_DONE
    results: [], // Results
    query: "", // Search query

    pos: {x: 0, y: 0, z: 0}
}

export default function (state=defaultState, action) {

    switch (action.type) {

        case "SEARCH_FETCH":
            return Object.assign({}, state, {
                state: "SEARCH_FETCHING",
                query: action.query
            })
        
        case "SPEECH_END":
            if (action.searchType === "IMAGE_SEARCH")
                return Object.assign({}, state, {
                    state: "SEARCH_FETCHING",
                    query: action.result
                }) 
            else if (action.searchType === "TEXT_SEARCH")
                return Object.assign({}, state, {
                    state: "SEARCH_INSERT_TEXT",
                    query: action.result
                })
            else
                return state
        
        case "KEYBOARD_SUBMIT":
            if (action.searchType === "IMAGE_SEARCH")
                return Object.assign({}, state, {
                    state: "SEARCH_FETCHING",
                    query: action.result
                }) 
            else if (action.searchType === "TEXT_SEARCH")
                return Object.assign({}, state, {
                    state: "SEARCH_INSERT_TEXT",
                    query: action.result
                })
            else
                return state
        
        case "SEARCH_ERROR":
            return Object.assign({}, state, {
                state: "SEARCH_DONE",
            })

        case "SEARCH_DONE":
            console.log('[REDUX SEARCH_DONE]:', action.results)

            return Object.assign({}, state, {
                state: "SEARCH_DONE",
                results: action.results,

                pos: {x: action.x, y: action.y, z: 0}
            })

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/search.js